import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];

const TESTIMONIALS = [
  {
    name: "Álvaro Gósen",
    business: "Gosén Food · Restauración",
    text: "Nos rediseñaron el logo, los menús y la ficha de Google. En tres meses hemos pasado a ser de los primeros resultados de la zona y las reservas lo notan.",
    service: "Branding + Google Business",
  },
  {
    name: "Deborah M.",
    business: "Tienda Debraham · E-commerce",
    text: "Me montaron la tienda online completa en Shopify, con el catálogo y los pagos funcionando. En dos semanas estaba vendiendo. Trato cercano y rapidísimo.",
    service: "Tienda Online Shopify",
  },
  {
    name: "Marina López",
    business: "Estudio AB · Servicios",
    text: "Llevan nuestro Instagram desde hace medio año: publicaciones, reels y respuestas a clientes. Hemos duplicado seguidores y llegan consultas cada semana.",
    service: "Community Manager",
  },
];

export default function Testimonials() {
  return (
    <section id="opiniones" className="relative py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6">
        <p className="mb-4 font-mono-sig text-xs font-bold uppercase tracking-[0.3em] text-[#1D4ED8]">
          ( 03 ) — Opiniones
        </p>
        <h2 className="mb-16 max-w-3xl font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-slate-900">
          Lo que dicen quienes ya despegaron.
        </h2>

        <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
          {TESTIMONIALS.map((t, i) => (
            <motion.blockquote
              key={t.name}
              data-testid={`testimonial-card-${i + 1}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, ease: EASE, delay: i * 0.1 }}
              className="group flex flex-col justify-between rounded-3xl border border-slate-200 bg-white p-8 transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl hover:shadow-slate-900/10"
            >
              <div>
                <div className="mb-5 flex items-center justify-between">
                  <div className="flex gap-1">
                    {[...Array(5)].map((_, s) => (
                      <Star key={s} className="h-4 w-4 fill-[#FF9F00] text-[#FF9F00]" />
                    ))}
                  </div>
                  <Quote className="h-6 w-6 text-slate-200 transition-colors group-hover:text-[#00F0FF]" />
                </div>
                <p className="text-base leading-relaxed text-slate-700">“{t.text}”</p>
              </div>
              <footer className="mt-8 border-t border-slate-100 pt-5">
                <p className="font-display font-bold text-slate-900">{t.name}</p>
                <p className="text-sm text-slate-500">{t.business}</p>
                <p className="mt-2 inline-block rounded-full bg-[#1D4ED8]/10 px-3 py-1 font-mono-sig text-[10px] font-bold uppercase tracking-widest text-[#1D4ED8]">
                  {t.service}
                </p>
              </footer>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}
